
export const FETCH_RB_REPORTS_REQUEST = "FETCH_RB_REPORTS_REQUEST";
export const FETCH_RB_REPORTS_SUCCESS = "FETCH_RB_REPORTS_SUCCESS";
export const FETCH_RB_REPORTS_ERROR = "FETCH_RB_REPORTS_ERROR";
export const CLOSE_ERROR_MESSAGE_POPUP = "CLOSE_ERROR_MESSAGE_POPUP";
